export default __webpack_public_path__ + "static/janan-068f9670bc595af0d3efee7bfdfcf1f7.png";